/* HEIMWEH — Zeilenhoehen im Warenkorb stabil halten
 *
 * URSACHE DES PREISSPRUNGS
 * cart.js setzt in syncCartHeights() die Hoehe von .cart-item-details und
 * .cart-item-right auf die Bildhoehe. Der Preis sitzt dadurch unten.
 * Aufgerufen wird das am ENDE von CartItems.onCartUpdate() — davor steht aber
 * ein trapFocus(). Nach dem Entfernen eines Artikels findet
 * querySelector('.cart-item__title') nichts mehr, trapFocus bekommt null:
 *
 *   TypeError: Cannot read properties of null (reading 'focus')
 *     at Object.trapFocus (theme.js:77)
 *     at CartItems.onCartUpdate (cart.js:308)
 *
 * Die Funktion bricht ab, syncCartHeights() laeuft nie, die Hoehen fehlen —
 * der Preis rutscht nach oben.
 *
 * AUFBLITZEN BEIM LADEN
 * getBoundingClientRect().height liefert 0, solange das Bild nicht geladen
 * ist. Deshalb wird die Hoehe zuerst aus den width/height-Attributen und der
 * Spaltenbreite berechnet — die stehen bereits beim Parsen fest.
 *
 * MIN-HEIGHT STATT HEIGHT (22.10.2026)
 * Vorher wurde eine FESTE Hoehe gesetzt. Passt der Textblock nicht hinein,
 * laeuft er unten aus dem Kasten heraus. Jetzt min-height: der Preis sitzt
 * weiterhin unten und springt nicht, die Spalte darf aber mitwachsen.
 *
 * --hw-img-h (22.10.2026)
 * Zusaetzlich wird die gemessene Bildhoehe als CSS-Variable am Warenkorb-
 * Element hinterlegt. Das mobile Gitter in assets/mandasa.css braucht sie,
 * damit die erste Gitterreihe GENAU so hoch ist wie das Bild — unabhaengig
 * davon, wie lang der Produkttext ist. Ohne das verteilt CSS Grid die Hoehe
 * eines ueber beide Reihen gespannten Textes auf beide Reihen, die erste
 * waechst mit, und der Mengenwaehler rutscht je nach Textlaenge
 * unterschiedlich weit unter das Bild. Genau das sah bei langen Titeln
 * (z.B. Runder Beistelltisch Dario) anders aus als bei kurzen.
 * Verwendet wird die Variable in assets/hw-weihnachten.js.
 *
 * cart.js und theme.js bleiben unangetastet.
 */
(function () {
  if (window.__hwCartHeights) return;
  window.__hwCartHeights = true;

  var TARGETS = ['.cart-item-details', '.cart-item-right'];

  /* Hoehe ermitteln — gemessen, sonst aus dem Seitenverhaeltnis geschaetzt */
  function heightOf(img) {
    var measured = img.getBoundingClientRect().height;
    if (measured) return measured;

    var aw = parseFloat(img.getAttribute('width'));
    var ah = parseFloat(img.getAttribute('height'));
    if (!aw || !ah) return 0;

    var box = img.getBoundingClientRect().width;
    if (!box && img.parentElement) box = img.parentElement.getBoundingClientRect().width;
    if (!box) return 0;

    return box * (ah / aw);
  }

  function applyOne(item) {
    var img = item.querySelector('.cart-item-image img');
    if (!img) return;

    var h = heightOf(img);
    if (!h) return;

    var px = Math.round(h) + 'px';

    if (item.style.getPropertyValue('--hw-img-h') !== px) {
      item.style.setProperty('--hw-img-h', px);
    }

    TARGETS.forEach(function (sel) {
      var el = item.querySelector(sel);
      if (!el) return;
      if (el.style.height) el.style.height = '';
      if (el.style.minHeight !== px) el.style.minHeight = px;
    });
  }

  function applyAll() {
    var items = document.querySelectorAll('.cart-item');
    for (var i = 0; i < items.length; i++) applyOne(items[i]);
  }

  var frame = null;
  var tail = [];
  function schedule() {
    applyAll();
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      frame = null;
      applyAll();
      tail.forEach(clearTimeout);
      tail = [60, 200, 500].map(function (ms) { return setTimeout(applyAll, ms); });
    });
  }

  function observeImages() {
    document.querySelectorAll('.cart-item .cart-item-image img').forEach(function (img) {
      if (img.__hwObs) return;
      img.__hwObs = true;

      var fix = function () {
        var item = img.closest('.cart-item');
        if (item) applyOne(item);
      };

      if (typeof ResizeObserver !== 'undefined') new ResizeObserver(fix).observe(img);
      img.addEventListener('load', fix);
      if (img.decode) img.decode().then(fix).catch(function () {});
    });
  }

  function tick() {
    schedule();
    observeImages();
  }

  function boot() {
    tick();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length || records[i].removedNodes.length) { tick(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  ['cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, tick);
  });
  window.addEventListener('resize', schedule);
  window.addEventListener('load', tick);
  window.addEventListener('pageshow', tick);

  if (document.body) tick();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();